
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

import 'babel-polyfill'
require('spark-bootstrap');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    // authEndpoint : 'http://orderingsimple.com/public/broadcasting/auth',
    broadcaster: 'pusher',
    key: (process.env.NODE_ENV === 'production' ? 'f2ab62e35033ce1d6311' : 'ea1c7885fa49fbf4c8c8'),
	cluster: 'eu'
});

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

let Sentry = require('@sentry/browser');
let Integrations = require('@sentry/integrations');
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://a229863a70f14ce1bf31965e7e06fbcd@sentry.io/1783870',
        integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    });
}

const opts = {
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: "#4CAF50",
                secondary: '#424242',
                accent: '#1976D2',
                success: '#4CAF50',
                info: '#2196F3',
                warning: '#ffc107',
                error: '#FF5252',
            },
            dark: {
                primary: "#ffa000",
                secondary: '#424242',
                accent: '#5c6bc0',
                success: '#7cb342',
                info: '#2196f3',
                warning: '#fb8c00',
                error: '#c62828',
            }
        }
    }
};
Vue.use(Vuetify);

import { store } from './store/store';
import { router } from './routes/routes';

require('./mixins/global');
require('./components/bootstrap');

var VueScrollactive = require('vue-scrollactive');
Vue.use(VueScrollactive);

var app = new Vue({
	store,
    router,
    vuetify: new Vuetify(opts),
    mixins: [require('spark')],
	computed: {
		session_modal() {
			let modal = document.getElementById('modal-session-expired');
			return modal.classList.contains('active') ? true : false;
		}
	},
	created() {
        Bus.$on('getCurrentTeam', () => {
            this.getCurrentTeam();
        });

        Bus.$on('showSupportForm', () => {
            if (this.user) {
                this.supportForm.from = this.user.email;
            }

            this.support_modal = true;
        });
	},
    data() {
        return {
            support_modal: false
        };
    },
    methods: {
        sendSupportRequest() {
            Spark.post('/support/email', this.supportForm)
                .then(() => {
                    this.support_modal = false;
                    this.showSupportRequestSuccessMessage();

                    this.supportForm.subject = '';
                    this.supportForm.message = '';
                });
        }
    }
});
